<div
    [formGroup]="scheduleForm"
    *transloco="let t"
    class="bazis-schedule-control"
>
    <div
        formArrayName="schedule"
        *ngIf="{
            valueChanges: valueChanges$ | async,
            required: required$ | async,
        } as data"
    >
        <h6
            *ngIf="titleKey"
            class="bazis-form__group-title"
        >
            {{ t(titleKey, titleParams) }}
            <span
                color="danger"
                *ngIf="data.required"
            >
                *
            </span>
        </h6>

        <table class="bazis-table_schedule">
            <colgroup>
                <col />
                <col />
                <col />
                <col width="100" />
            </colgroup>
            <thead>
                <tr>
                    <th>{{ t('form.title.schedule.days') }}</th>
                    <th>{{ t('form.title.schedule.work') }}</th>
                    <th>{{ t('form.title.schedule.rest') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let scheduleLine of schedule.controls; let i = index">
                    <tr [formGroupName]="i">
                        <td>
                            <bazis-select
                                [id]="anchorRoot ? anchorRoot + '-days-' + i : null"
                                [options]="daysOfWeek"
                                formControlName="days"
                                (touched)="markAsTouched()"
                            ></bazis-select>
                        </td>
                        <td>
                            <bazis-input-timeinterval
                                [id]="anchorRoot ? anchorRoot + '-work-' + i : null"
                                formControlName="workingHours"
                                [showIntervalCheckbox]="false"
                                [showDayAndNightCheckbox]="false"
                                (touched)="markAsTouched()"
                            ></bazis-input-timeinterval>
                        </td>
                        <td>
                            <bazis-input-timeinterval
                                [id]="anchorRoot ? anchorRoot + '-rest-' + i : null"
                                formControlName="restHours"
                                [showIntervalCheckbox]="false"
                                [showDayAndNightCheckbox]="false"
                                (touched)="markAsTouched()"
                            ></bazis-input-timeinterval>
                        </td>
                        <td class="bazis-table__cell_action">
                            <bazis-button
                                class="bh-float-right"
                                fill="outline"
                                [disabled]="schedule.controls.length <= 1 || scheduleForm.disabled"
                                (click)="removeSchedule(i)"
                            >
                                <bazis-icon
                                    slot="icon-only"
                                    [name]="icons.trash"
                                ></bazis-icon>
                            </bazis-button>
                        </td>
                    </tr>
                    <tr
                        *ngIf="
                            scheduleLine.controls.days.valid &&
                            scheduleLine.controls.workingHours.valid &&
                            scheduleLine.controls.restHours.valid &&
                            scheduleLine.invalid
                        "
                    >
                        <td colspan="4">
                            <div class="bazis-control__error">
                                {{ t('form.error.invalidScheduleRow') }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <bazis-button
            color="action"
            fill="outline"
            *ngIf="schedule.controls.length < 7 && schedule.enabled"
            (click)="addScheduleGroup()"
        >
            <bazis-icon
                slot="start"
                [name]="icons.plus"
            ></bazis-icon>
            {{ t(addButtonTitleKey) }}
        </bazis-button>
    </div>
</div>
